import type { TBreadcrumbsConfig } from "@lib/interface/layout";
import { ComputedRef, onBeforeUnmount, ref, watch } from "vue";

const breadcrumbsConfig = ref<TBreadcrumbsConfig | undefined>(undefined);

// Should be computed because of reactive translations
export default function useBreadcrumbs(config?: ComputedRef<TBreadcrumbsConfig | undefined>) {
  const setBreadcrumbsConfig = (config: TBreadcrumbsConfig | undefined) => {
    breadcrumbsConfig.value = config;
  };
  if (config) {
    const unwatch = watch(config, setBreadcrumbsConfig, {
      immediate: true,
    });
    onBeforeUnmount(unwatch);
  }
  return {
    breadcrumbsConfig,
    setBreadcrumbsConfig,
  };
}
